import StepLayout from './StepLayout';
import AddressPicker, { isManualAddressComplete } from './AddressPicker';
import {
    addressFormStore,
    modalToggleStore,
    toggleStore,
    userFormStore,
} from '../../../store/Store';

const Profile4 = () => {
    const addressForm = addressFormStore.useState((s) => s.addressForm);
    const detailUserForm = userFormStore.useState((s) => s.detailUserForm);
    const manualAddress = toggleStore.useState((s) => s.manualAddress);

    // The final step saves the typed fields when entered manually, otherwise
    // the address picked from the search, so validity follows the same rule.
    const valid = manualAddress
        ? isManualAddressComplete(addressForm)
        : Boolean(detailUserForm.address);

    const openFifthPage = () => {
        modalToggleStore.update((s) => {
            s.profilePage = 5;
        });
    };

    return (
        <StepLayout
            title='What is your address?'
            primaryLabel='Continue'
            onPrimary={openFifthPage}
            primaryDisabled={!valid}
            hint={valid ? undefined : 'Search for or enter your address to continue.'}
        >
            <AddressPicker idPrefix='profile-address' />
        </StepLayout>
    );
};

export default Profile4;
